/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface UserProfileAPI
	 * @classdesc API class that defines the user profile information that is accessible in a dashboard.
	 * @example dashboard.getFeature('UserProfile')
	 * @example appFactory.getFeature('UserProfile')
	 */
	class UserProfileAPI {

		/**
		 * @param {string} capabilityName - Name of the capabilities:
		 * <ul>
		 * <li>canAuthorDashboard</li>
		 * <li>canUseInteractiveDashboard</li>
		 * </ul>
		 *
		 * @returns {boolean} Returns 'true' if the capability is known and enabled; false otherwise.
		 * @example
		 *  if (userProfile.hasCapability('canAuthorDashboard') === true) {
		 *    //do something
		 *  } else {
		 *    // do something else
		 *  }
		 */
		hasCapability() {}

		/**
		 * @returns {string} user content locale. Defaults to 'en'
		 */
		getContentLocale() {}

		/**
		 * @returns {string} user content locale. Defaults to 'en'
		 */
		getProductLocale() {}

		/*
		 * @async
		 * @return Promise<Object> - Promise resolved with a JSON object that contains all available content locales
		 * @example
		 * 	{
				en: 'English',
				fr: 'French',
				af: 'Afrikaans',
				de: 'German',
				zh: 'Chinese'
		 * 	}
		 */
		getAvailableContentLocales(){}

		/**
		 * @returns {Object} The user's account information including {defaultName, userName}
		 */
		getUserAccount() {}

		/**
		 * @returns {String} - A list of valid domains, separated by coma, null or empty string means all domains are supported
		 * @example
		 * 	'localhost,www.ibm.com,www.domainport.com:80, .onelevel.com ,*.alllevels.com,.mixed.com:80'
		 */
		getValidDomainList() {}
	}

	return UserProfileAPI;
});
